'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishMessage = exports.publishMessageFailed = exports.publishMessageSucceeded = exports.publishMessageStarted = undefined;

var _asyncActionTypes = require('../../pubsub/constants/asyncActionTypes');

var _reduxActions = require('redux-actions');

var _pubSubClientGetters = require('conversations-internal-pub-sub/redux/selectors/pubSubClientGetters');

var _buildPublishFailedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildPublishFailedMessage');

var _PubNubMessageSerializer = require('conversations-schema/serializers/PubNubMessageSerializer');

var _updateMessageInConversation = require('../../actions/ConversationsActions/updateMessageInConversation');

var _buildMessageKey = require('conversations-schema/pubnub-message/operators/buildMessageKey');

var _isClosed = require('conversations-schema/thread/operators/isClosed');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _cmfQuickReplyGetters = require('conversations-schema/common-message-format/operators/cmfQuickReplyGetters');

var _getThreadByThreadId = require('../../threads/selectors/getThreadByThreadId');

var publishMessageStarted = exports.publishMessageStarted = (0, _reduxActions.createAction)(_asyncActionTypes.PUBLISH_MESSAGE.STARTED);
var publishMessageSucceeded = exports.publishMessageSucceeded = (0, _reduxActions.createAction)(_asyncActionTypes.PUBLISH_MESSAGE.SUCCEEDED);
var publishMessageFailed = exports.publishMessageFailed = (0, _reduxActions.createAction)(_asyncActionTypes.PUBLISH_MESSAGE.FAILED);

var publishMessage = exports.publishMessage = function publishMessage(_ref) {
  var channel = _ref.channel,
      message = _ref.message,
      threadId = _ref.threadId;
  return function (dispatch, getState) {
    dispatch(publishMessageStarted({
      channel: channel,
      message: message,
      messageKey: (0, _buildMessageKey.buildMessageKey)(message),
      threadId: threadId
    }));

    var client = (0, _pubSubClientGetters.getPubSubClient)(getState());

    var publishData = {
      message: (0, _PubNubMessageSerializer.serialize)(message),
      channel: channel
    };

    var promise = client.publish(publishData).then(function (_ref2) {
      var json = _ref2.data;

      var publishedMessage = (0, _PubNubMessageSerializer.deserialize)({ json: json });

      dispatch(publishMessageSucceeded({
        channel: channel,
        messageKey: (0, _buildMessageKey.buildMessageKey)(message),
        publishedMessage: publishedMessage,
        threadId: threadId
      }));
      dispatch((0, _updateMessageInConversation.updateMessageInConversation)({
        updated: publishedMessage,
        channel: channel,
        message: message,
        threadId: threadId
      }));
    }).catch(function (error) {
      var failed = (0, _buildPublishFailedMessage.buildPublishFailedMessage)(message);

      dispatch(publishMessageFailed({
        channel: channel,
        messageKey: (0, _buildMessageKey.buildMessageKey)(message),
        message: message,
        threadId: threadId,
        error: error
      }));
      dispatch((0, _updateMessageInConversation.updateMessageInConversation)({
        updated: failed,
        channel: channel,
        message: message,
        threadId: threadId
      }));
    });

    try {
      var thread = (0, _getThreadByThreadId.getThreadByThreadId)(getState(), { threadId: threadId });
      var isQuickReplyResponse = Boolean((0, _cmfQuickReplyGetters.getQuickReply)(message));

      if ((0, _messageTypeComparators.isConversationalMessage)(message) && !isQuickReplyResponse && (0, _isClosed.isClosed)(thread)) {
        window.Raven.captureMessage('VISITOR_MESSAGE_PUBLISHED_ON_CLOSED_THREAD', {
          extra: {
            threadId: threadId,
            publishData: publishData
          }
        });
      }
    } catch (e) {
      // error
    }

    promise.done();
    return promise;
  };
};